webpackJsonp([1],{

/***/ "0MoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'detail',
	methods: {
		playTrailer: function playTrailer() {
			this.$store.commit('trailer', this.$store.state.projection.movie.youtube);
		},
		shareFacebook: function shareFacebook() {
			var popup = function popup(url, title, w, h) {
				var left = screen.width / 2 - w / 2;
				var top = screen.height / 2 - h / 2;
				return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
			};
			popup(this.shareFacebookUrl, 'Facebook', 800, 600);
		}
	},
	computed: {
		projection: function projection() {
			return this.$store.state.projection;
		},
		movie: function movie() {
			return this.$store.state.projection.movie;
		},
		poster: function poster() {
			var image = false;
			if (this.$store.state.projection.movie && this.$store.state.projection.movie.image) {
				if (this.$store.state.projection.movie.image.indexOf('http') !== -1) {
					image = btoa(unescape(encodeURIComponent(this.$store.state.projection.movie.image)));
				} else {
					image = this.$store.state.projection.movie.image;
				}
			}
			return image ? 'background-image: url("https://www.artkina.cz/api/1.2/image/200/200/' + image + '/"); background-size: cover;' : '';
		},
		day: function day() {
			return __WEBPACK_IMPORTED_MODULE_1_moment__(this.$store.state.projection.date.date).format('DD.MM.');
		},
		time: function time() {
			return __WEBPACK_IMPORTED_MODULE_1_moment__(this.$store.state.projection.date.date).format('HH:mm');
		},
		youtube: function youtube() {
			return 'https://www.youtube.com/' + this.$store.state.projection.movie.youtube;
		},
		fake: function fake() {
			return typeof this.$store.state.projection.fake !== 'undefined' ? 'is-skeleton' : '';
		},
		cinema: function cinema() {
			var cinema = this.$store.getters.selectedCinemas(this.projection.cinema_id);
			var mapsKey = 'AIzaSyBCJIbOMjUM-hXLJtET4qtHy3Oab9LJgog';
			var richCinema = {
				mailto: 'mailto:' + cinema.email,
				tel: 'tel:' + cinema.phone,
				map: 'https://maps.googleapis.com/maps/api/staticmap?key=' + mapsKey + '&center=' + cinema.gps + '&zoom=16&size=240x150&scale=1&style=null&sensor=false&markers=icon:https://www.artkina.cz/www/images/cinemas/pin-' + cinema.slug + '.png|' + cinema.gps
			};
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cinema, richCinema);
		},
		cinemaLogo: function cinemaLogo() {
			var cinema = this.$store.getters.selectedCinemas(this.projection.cinema_id);
			return 'background-image: url(https://www.artkina.cz/img/kino-' + cinema.slug + '.png);';
		},
		shareFacebookUrl: function shareFacebookUrl() {
			var url = 'https://moje.artkina.cz' + this.$route.fullPath;
			return 'https://www.facebook.com/dialog/share?app_id=628733673908917&display=popup&href=' + url + '&redirect_uri=' + url;
		}
	}
});

/***/ }),

/***/ "0xle":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__ = __webpack_require__("5KfQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: { LightboxBase: __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__["a" /* default */] },
	computed: {
		close: function close() {
			return function () {
				document.querySelector('html').classList.remove('lightbox--active');
				document.querySelector('html').classList.remove('lightbox--active-mobile');
				var nextWeek = new Date().getTime() + 7 * 24 * 3600 * 1000;
				localStorage.setItem('mobilePopup', nextWeek);
			};
		}
	},
	methods: {}
});

/***/ }),

/***/ "3i1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LightboxBase',{staticClass:"about",attrs:{"close":_vm.close}},[_c('div',{staticClass:"about__column about__column--left"},[_c('h2',[_vm._v("ART KINA")]),_vm._v(" "),_c('p',[_vm._v("Máte rádi klidná a přátelská kina místo přeplněných multiplexů? Preferujete pivo či víno před popkornem s količkou? Pak takhle praktická věc nesmí chybět ve vašem mobilu či tabletu.")]),_vm._v(" "),_c('p',[_vm._v("V aplikaci naleznete jak informace o promítání a ceně, tak detailní popisy filmů. Nechcete si nechat ujít konkrétní film? Notifikace vám projekci jednoduše připomene.")]),_vm._v(" "),_c('p',[_vm._v("Vyhledávat můžete v programu art kin těchto 4 měst: Praha, Brno, Ostrava, Hradec Králové.")]),_vm._v(" "),_c('h4',[_vm._v("KE STAŽENÍ ZDARMA")]),_vm._v(" "),_c('ul',{staticClass:"downloads"},[_c('li',[_c('a',{staticClass:"appstore",attrs:{"href":"http://bit.ly/aiosweb","target":"_blank"}},[_vm._v("App Store")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"googleplay",attrs:{"href":"http://bit.ly/akgpweb","target":"_blank"}},[_vm._v("Google Play")])])])]),_vm._v(" "),_c('div',{staticClass:"about__column about__column--right"},[_c('h3',[_vm._v("Artkina Ukovali")]),_vm._v(" "),_c('h4',[_vm._v("Jan Blaško")]),_vm._v(" "),_c('p',[_vm._v("Luke Skywalker projektu Artkina.cz. Krom toho zapálený vývojář žijící v Sydney, milovník Aronofského, komiksů a dobrýho kafe."),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://144.wtf","target":"_blank"}},[_vm._v("144.wtf")])]),_vm._v(" "),_c('h4',[_vm._v("GoodShape")]),_vm._v(" "),_c('p',[_vm._v("Kreativní internetová agentura. Vytváříme webové prezentace, mobilní aplikace a online marketingové strategie. Klademe velký důraz na design produktu a precizní provedení."),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://www.goodshape.cz","target":"_blank"}},[_vm._v("www.goodshape.cz")])]),_vm._v(" "),_c('p',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.date)+" Jan Blaško, GoodShape s.r.o.")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4fAa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5KfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxBase_vue__ = __webpack_require__("MwnA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e91e366a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxBase_vue__ = __webpack_require__("HQ2L");
function injectStyle (ssrContext) {
  __webpack_require__("u25I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxBase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e91e366a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxBase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5sNZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6SfK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__ = __webpack_require__("5KfQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: { LightboxBase: __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__["a" /* default */] },
	computed: {
		date: function date() {
			return new Date().getFullYear();
		},
		close: function close() {
			return function () {
				document.querySelector('html').classList.remove('lightbox--active');
				document.querySelector('html').classList.remove('lightbox--active-about');
			};
		}
	},
	methods: {}
});

/***/ }),

/***/ "7C3i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramItem_vue__ = __webpack_require__("7wox");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0873ed58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramItem_vue__ = __webpack_require__("B/9E");
function injectStyle (ssrContext) {
  __webpack_require__("hyUH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0873ed58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0873ed58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7osB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7wox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_helpers__ = __webpack_require__("s6Ya");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'program-item',
	props: ['projection', 'index'],
	data: function data() {
		return {
			day: null
		};
	},

	computed: {
		/**
   * Get the movie poster
   */
		poster: function poster() {
			var image = false;
			if (this.projection.movie.image) {
				if (this.projection.movie.image.indexOf('http') !== -1) {
					image = btoa(unescape(encodeURIComponent(this.projection.movie.image)));
				} else {
					image = this.projection.movie.image;
				}
			}
			return image ? 'background-image: url("https://www.artkina.cz/api/1.2/image/200/200/' + image + '/"); background-size: cover;' : '';
		},

		/**
   * Get the projection time
   */
		time: function time() {
			return __WEBPACK_IMPORTED_MODULE_0_moment__(this.projection.date.date).format('HH:mm');
		},

		dateName: function dateName() {
			return __WEBPACK_IMPORTED_MODULE_1__libs_helpers__["a" /* default */].nameTheDate(this.day);
		},

		cinemaLogo: function cinemaLogo() {
			var cinema = this.$store.getters.selectedCinemas(this.projection.cinema_id);
			return 'background-image: url(https://www.artkina.cz/img/kino-' + cinema.slug + '.png);';
		}
	},
	created: function created() {
		var formatedDate = __WEBPACK_IMPORTED_MODULE_0_moment__(this.projection.date.date).format('DD.MM.YYYY');
		if (this.$store.state.programDateHeader !== formatedDate) {
			this.$store.commit('programDateHeader', formatedDate);
			this.day = formatedDate;
		} else {
			this.day = null;
		}
	}
});

/***/ }),

/***/ "8jD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"menu"},[_c('ul',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',{staticClass:"about"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.openAboutLightbox()}}},[_vm._v("Informace")])])])]),_vm._v(" "),_c('aside',[_c('nav',[_c('ul',[(_vm.hasPreviousBtn)?_c('li',{staticClass:"back"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showSection('previous')}}},[_vm._v(_vm._s(_vm.prevSection.title))])]):_vm._e(),_vm._v(" "),(_vm.hasNextBtn)?_c('li',{staticClass:"next"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showSection('next')}}},[_vm._v(_vm._s(_vm.nextSection.title))])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('a',{attrs:{"href":"/","title":"Zkušební promítání"}},[_vm._v("ArtKina"),_c('span',[_vm._v(" - Program artových kin v ČR")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"appstore"},[_c('a',{attrs:{"href":"http://bit.ly/aiosweb","target":"_blank"}},[_c('span',[_vm._v("App Store")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"googleplay"},[_c('a',{attrs:{"href":"http://bit.ly/akgpweb","target":"_blank"}},[_c('span',[_vm._v("Google Play")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8wj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Heading_vue__ = __webpack_require__("dfjV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07b514e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Heading_vue__ = __webpack_require__("8jD3");
function injectStyle (ssrContext) {
  __webpack_require__("Rx05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07b514e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Heading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07b514e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Heading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9YM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LightboxBase',{staticClass:"trailer",attrs:{"close":_vm.close}},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url,"frameborder":"0","allowfullscreen":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B/9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.day !== null)?_c('h3',[_vm._v(_vm._s(_vm.dateName)+" "),_c('span',[_vm._v(_vm._s(_vm.day))])]):_vm._e(),_vm._v(" "),(_vm.index % 5 === 0 && _vm.index !== 0)?_c('div',[_c('InFeedAdsense',{attrs:{"data-ad-layout-key":"-fg+5t+6e-gc+67","data-ad-client":"ca-pub-8746296356969794","data-ad-slot":"2388712700","data-ad-test":this.$store.getters.debug ? 'on' : 'off'}})],1):_vm._e(),_vm._v(" "),_c('article',[_c('div',{staticClass:"program__poster",style:(_vm.poster)}),_vm._v(" "),_c('div',{staticClass:"program__detail",style:(_vm.cinemaLogo)},[_c('h4',[_c('span',{staticClass:"cinema"},[_vm._v("Kino Svetozor:")]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.time)+":")]),_vm._v(" "+_vm._s(_vm.projection.movie.title))]),_vm._v(" "),_c('ul',[(_vm.projection.language)?_c('li',[_vm._v(_vm._s(_vm.projection.language))]):_vm._e(),_vm._v(" "),(_vm.projection.price || _vm.projection.movie.year)?_c('li',[(_vm.projection.movie.year)?_c('span',[_vm._v(_vm._s(_vm.projection.movie.year)),(_vm.projection.price)?_c('span',[_vm._v(", ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.projection.price)?_c('span',[_vm._v(_vm._s(_vm.projection.price)+" Kč")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('li',[(_vm.projection.imdb_rating)?_c('span',{staticClass:"rating-1"},[_vm._v("IMDB: "+_vm._s(_vm.projection.imdb_rating))]):_vm._e(),_vm._v(" "),(_vm.projection.csfd_rating)?_c('span',{staticClass:"rating-2"},[_vm._v("ČSFD: "+_vm._s(_vm.projection.csfd_rating))]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bb2j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Br1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_program_ProgramItem__ = __webpack_require__("7C3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_string__ = __webpack_require__("kKhF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_helpers__ = __webpack_require__("s6Ya");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'program',
	components: {
		'program-item': __WEBPACK_IMPORTED_MODULE_1__components_program_ProgramItem__["a" /* default */]
	},
	data: function data() {
		return {
			headings: []
		};
	},
	mounted: function mounted() {
		var self = this;
		self.$('#program .content-wrapper', 0).addEventListener('scroll', function (e) {
			var scrollTop = e.target.scrollTop - self.$('#program h3.program__date', 0).clientHeight; // -> offset

			// const heading = self.headings.find(el => scrollTop >= el.offsetTop)
			// const heading = self.headings.reduce((a, b) => a.offsetTop >= scrollTop <= b.offsetTop ? b : a)
			var heading = null;
			self.headings.forEach(function (el) {
				heading = scrollTop > el.offsetTop ? el : heading;
			});

			if (heading) {
				self.$('#program h3.program__date', 0).innerHTML = heading.element.innerHTML;
			} else {
				self.$('#program h3.program__date', 0).innerHTML = self.mainHeaderHTML;
			}
		});
	},
	updated: function updated() {
		var self = this;
		self.headings = [];
		self.$('#program .content-wrapper h3').forEach(function (el) {
			self.headings.push({ element: el, offsetTop: el.offsetTop });
		});
	},

	computed: {
		projections: function projections() {
			return this.$store.state.projections;
		},
		statusClass: function statusClass() {
			return this.$store.state.statuses.projections ? 'active' : 'inactive';
		},
		mainHeaderHTML: function mainHeaderHTML() {
			var date = this.$store.state.programDateHeaderFirst === null ? '' : this.$store.state.programDateHeaderFirst;
			var dateName = __WEBPACK_IMPORTED_MODULE_3__libs_helpers__["a" /* default */].nameTheDate(date);
			return dateName + ' <span>' + date + '</span>';
		},
		loadingCopy: function loadingCopy() {
			return this.$store.state.statuses.projections ? 'Načíst další' : 'Načítám...';
		}
	},
	methods: {
		selectProjection: function selectProjection(projection) {
			this.$store.commit('projection', projection);
			this.$router.push('/' + __WEBPACK_IMPORTED_MODULE_2_string__(projection.movie.title).slugify().s + '/' + projection.id + '/');
		},
		loadMore: function loadMore() {
			this.$store.dispatch('loadMore');
		},
		$: function $(selector) {
			var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var el = document.querySelectorAll(selector);
			if (el) {
				if (el[index]) {
					return el[index];
				}
				return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(el));
			}
			return [];
		}
	}
});

/***/ }),

/***/ "HQ2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('div',{staticClass:"lightbox"},[_c('div',{staticClass:"lightbox__content"},[_c('div',{staticClass:"lightbox__wrapper"},[_c('div',{staticClass:"lightbox__wrapper--inner"},[_vm._t("default")],2)]),_vm._v(" "),_c('a',{staticClass:"lightbox__close",attrs:{"href":"#close"},on:{"click":function($event){$event.preventDefault();_vm.close()}}},[_c('span',[_vm._v("Zavrit")])])])]),_vm._v(" "),_c('div',{staticClass:"lightbox lightbox__bg"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);







// import * as actions from './actions'
// import * as getters from './getters'
// import cart from './modules/cart'
// import products from './modules/products'
// import createLogger from '../../../src/plugins/logger'

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var _debug = "production" !== 'production';
var API_URL = 'https://www.artkina.cz/api/1.4';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
	state: {
		// Search query state
		search: {
			until: null,
			since: null,
			cinemas: null
		},

		// List of cinemas
		cinemas: [],

		// List of all projections
		projections: [],

		statuses: {
			cinemas: true,
			projections: true,
			detail: true
		},

		// Projection detail
		projection: {
			'fake': true,
			'date': {
				'date': '2017-09-15 23:00:00'
			},
			'price': 0,
			'language': 'vestibulum eu, molestie',
			'enabled': true,
			'id': 59550,
			'movie_id': 7069,
			'cinema_id': 1,
			'csfd_link': null,
			'csfd_rating': null,
			'imdb_rating': null,
			'movie': {
				'title': 'Nam ipsum risus',
				'title_orig': 'Nam ipsum risus',
				'year': 2017,
				'description': 'Nam ipsum risus, rutrum vitae, vestibulum eu, molestie vel, lacus. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Aliquam eu nunc. Curabitur a felis in nunc fringilla tristique. Sed fringilla mauris sit amet nibh. Praesent nec nisl a purus blandit viverra. Phasellus accumsan cursus velit. Ut id nisl quis enim dignissim sagittis. Sed augue ipsum, egestas nec, vestibulum et, malesuada adipiscing, dui. Suspendisse non nisl sit amet velit hendrerit rutrum. Sed cursus turpis vitae tortor. Etiam sit amet orci eget eros faucibus tincidunt. Morbi mattis ullamcorper velit. Fusce commodo aliquam arcu. Praesent nonummy mi in odio.',
				'length': 120,
				'country': 'Czech Republic',
				'id': 123,
				'youtube': null
			}
		},

		// Displayed trailer
		trailer: null,

		// Very first  date header in the program list
		programDateHeaderFirst: null,

		// What's the last displayed date header in the program list
		programDateHeader: null,

		// Index of currently active section on mobile (or tablet)
		activeSectionIndex: 1,

		sections: [{ title: 'Kina', slug: 'cinemas' }, { title: 'Program', slug: 'program' }, { title: 'Projekce', slug: 'detail' }]
	},
	mutations: {
		search: function search(state, _search) {
			state.search = _search;
		},
		cinemas: function cinemas(state, _cinemas) {
			state.cinemas = _cinemas;
		},
		toggleCinema: function toggleCinema(state, _ref) {
			var city = _ref.city,
			    index = _ref.index,
			    _ref$status = _ref.status,
			    status = _ref$status === undefined ? null : _ref$status;

			state.cinemas[city][index].active = status === null ? !state.cinemas[city][index].active : status;
		},
		projections: function projections(state, _ref2) {
			var projections = _ref2.projections,
			    _ref2$append = _ref2.append,
			    append = _ref2$append === undefined ? false : _ref2$append;

			if (append === false) {
				state.projections = projections;
			} else {
				state.projections = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.projections), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(projections));
			}
		},
		projection: function projection(state, payload) {
			state.projection = payload;
		},

		trailer: function trailer(state, payload) {
			if (payload) {
				document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-trailer');
			} else {
				document.querySelector('html').classList.remove('lightbox--active', 'lightbox--active-trailer');
			}
			state.trailer = payload;
		},
		statuses: function statuses(state, payload) {
			state.statuses = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.statuses, payload);
		},
		programDateHeader: function programDateHeader(state, date) {
			state.programDateHeader = date;
		},
		programDateHeaderFirst: function programDateHeaderFirst(state, date) {
			state.programDateHeaderFirst = date;
		},
		activeSectionIndex: function activeSectionIndex(state, index) {
			state.activeSectionIndex = index;
		}
	},
	getters: {
		apiUrl: function apiUrl() {
			return API_URL;
		},

		debug: function debug() {
			return _debug;
		},

		/**
   * Get selected cinemas - all, by slug or by id
   * @param slug|id
   * @return array
   */
		selectedCinemas: function selectedCinemas(state) {
			return function () {
				var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

				var cinemas = state.cinemas;
				var selectedCinemas = [];
				var selectedCinema = null;

				var _loop = function _loop(city) {
					cinemas[city].forEach(function (cinema, index) {
						if (cinemas[city][index].active) {
							if (parseInt(slug) === cinemas[city][index].id) {
								selectedCinema = cinemas[city][index];
							}
							if (slug === city || slug === null) {
								selectedCinemas.push(cinemas[city][index]);
							}
						}
					});
				};

				for (var city in cinemas) {
					_loop(city);
				}
				return selectedCinema !== null ? selectedCinema : selectedCinemas;
			};
		},

		activeSection: function activeSection(state) {
			return state.sections[state.activeSectionIndex];
		},

		getCinemas: function getCinemas(state) {
			var cinemas = state.cinemas;
			for (var slug in cinemas) {
				cinemas[slug].sort(function (a, b) {
					return a.name > b.name ? 1 : a.name === b.name ? 0 : -1;
				});
			}
			return cinemas;
		}
	},

	actions: {
		/**
   * Initial load of the cinemas
   * @param {*} state
   * @param {*} cities
   */
		cinemas: function cinemas(_ref3, cities) {
			var commit = _ref3.commit,
			    state = _ref3.state,
			    dispatch = _ref3.dispatch;

			var askForPosition = function askForPosition() {
				var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

				return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
					navigator.geolocation.getCurrentPosition(resolve, reject, options);
				});
			};

			var loadCinemas = function loadCinemas(cities, active) {
				var _loop2 = function _loop2(city) {
					cities[city].forEach(function (cinema, index) {
						cities[city][index].active = city === active;
					});
				};

				for (var city in cities) {
					_loop2(city);
				}
				commit('cinemas', cities);
			};

			var toggleClosestCinema = function toggleClosestCinema(cities) {
				var closest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				var _loop3 = function _loop3(city) {
					cities[city].forEach(function (cinema, index) {
						if (city === closest.city) {
							commit('toggleCinema', { city: city, index: index, status: true });
						} else {
							commit('toggleCinema', { city: city, index: index, status: false });
						}
					});
				};

				for (var city in cities) {
					_loop3(city);
				}
				dispatch('loadProjections');
			};

			var deg2rad = function deg2rad(deg) {
				return deg * (Math.PI / 180);
			};

			var getDistance = function getDistance(lat1, lon1, lat2, lon2) {
				var R = 6371; // Radius of the earth in km
				var dLat = deg2rad(lat2 - lat1); // deg2rad below
				var dLon = deg2rad(lon2 - lon1);
				var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

				var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				var d = R * c; // Distance in km
				return d;
			};

			loadCinemas(cities, 'Praha');
			dispatch('loadProjections');

			var closest = { city: 'Praha', distance: 0 };
			askForPosition().then(function (position) {
				var _position$coords = position.coords,
				    lat = _position$coords.latitude,
				    lng = _position$coords.longitude;

				for (var city in cities) {
					var cinema = cities[city][0]; // all we care about is one cinema from each city
					var distance = getDistance.apply(undefined, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(cinema.gps.split(',')).concat([lat, lng]));
					if (closest.distance === 0 || closest.distance > distance) {
						closest.city = city;
						closest.distance = distance;
					}
				}
				toggleClosestCinema(cities, closest);
			}).catch(function (err) {
				console.warn('ERROR(' + err.code + '): ' + err.message);
			});
		},


		/**
   * Load projections based on selected cinemas.
   */
		loadProjections: function loadProjections(_ref4) {
			var commit = _ref4.commit,
			    state = _ref4.state,
			    getters = _ref4.getters;

			var cinemas = '' + getters.selectedCinemas().map(function (cinema) {
				return cinema.slug;
			});

			// TODO: Refactor with moment
			var days = 2;
			var until = new Date((new Date().getTime() / 1000 + 24 * days * 3600) * 1000);
			var _ref5 = [until.getFullYear(), until.getMonth() + 1, until.getDate()],
			    year = _ref5[0],
			    month = _ref5[1],
			    day = _ref5[2];

			month = month < 10 ? '0' + month : month;
			day = day < 10 ? '0' + day : day;
			until = year + '-' + month + '-' + day;

			commit('statuses', { projections: false });
			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(API_URL + '/projection/list/' + cinemas + '/' + until).then(function (response) {
				// Sort by date
				response.data.data.sort(function (a, b) {
					return __WEBPACK_IMPORTED_MODULE_6_moment__(a.date.date).format('X') - __WEBPACK_IMPORTED_MODULE_6_moment__(b.date.date).format('X');
				});

				// Commit mutations
				commit('projections', { projections: response.data.data });
				commit('statuses', { projections: true });

				// Set the first date header in program
				var formatedDate = __WEBPACK_IMPORTED_MODULE_6_moment__(response.data.data[0].date.date).format('DD.MM.YYYY');
				commit('programDateHeaderFirst', formatedDate);
				commit('programDateHeader', formatedDate);

				// Update the search query
				commit('search', { until: until, cinemas: cinemas });
			}).catch(function (error) {
				console.warn(error);
				commit('statuses', { projections: true });
			});
		},
		toggleCity: function toggleCity(_ref6, city) {
			var commit = _ref6.commit,
			    state = _ref6.state,
			    dispatch = _ref6.dispatch;

			state.cinemas[city].forEach(function (cinema, index) {
				commit('toggleCinema', { city: city, index: index });
			});
			dispatch('loadProjections');
		},


		/**
   * Toggling cinemas. Once done, dispatch async action loadProjections.
   */
		toggleCinema: function toggleCinema(_ref7, toggledCinema) {
			var commit = _ref7.commit,
			    state = _ref7.state,
			    dispatch = _ref7.dispatch;

			var cinemas = state.cinemas;

			var _loop4 = function _loop4(city) {
				cinemas[city].forEach(function (cinema, index) {
					if (cinema === toggledCinema) {
						commit('toggleCinema', { city: city, index: index });
					}
				});
			};

			for (var city in cinemas) {
				_loop4(city);
			}
			dispatch('loadProjections');
		},


		/**
   * Load more projections
   */
		loadMore: function loadMore(_ref8) {
			var commit = _ref8.commit,
			    state = _ref8.state,
			    dispatch = _ref8.dispatch;
			var _state$search = state.search,
			    cinemas = _state$search.cinemas,
			    until = _state$search.until,
			    since = _state$search.since;

			since = until;
			until = __WEBPACK_IMPORTED_MODULE_6_moment__(until).add(1, 'days').format('YYYY-MM-DD');

			commit('statuses', { projections: false });
			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(API_URL + '/projection/list/' + cinemas + '/' + until + '/' + since).then(function (response) {
				// Sort by date
				response.data.data.sort(function (a, b) {
					return __WEBPACK_IMPORTED_MODULE_6_moment__(a.date.date).format('X') - __WEBPACK_IMPORTED_MODULE_6_moment__(b.date.date).format('X');
				});

				// Commit mutations
				commit('projections', { projections: response.data.data, append: true });

				// Update the search query
				commit('search', { until: until, since: since, cinemas: cinemas });

				commit('statuses', { projections: true });
			}).catch(function (error) {
				console.warn(error);
				commit('statuses', { projections: true });
			});
		}
	},
	strict: _debug
	// plugins: debug ? [createLogger()] : []
}));

/***/ }),

/***/ "JNZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Heading__ = __webpack_require__("8wj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cinemas__ = __webpack_require__("zGu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Program__ = __webpack_require__("VY5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Detail__ = __webpack_require__("wHgX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lightbox_LightboxTrailer__ = __webpack_require__("R3ok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_lightbox_LightboxAbout__ = __webpack_require__("llWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lightbox_LightboxMobile__ = __webpack_require__("bSCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lightbox_LightboxAdblock__ = __webpack_require__("iBsz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
	store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
	components: {
		Heading: __WEBPACK_IMPORTED_MODULE_1__components_Heading__["a" /* default */],
		Cinemas: __WEBPACK_IMPORTED_MODULE_2__components_Cinemas__["a" /* default */],
		Program: __WEBPACK_IMPORTED_MODULE_3__components_Program__["a" /* default */],
		Detail: __WEBPACK_IMPORTED_MODULE_4__components_Detail__["a" /* default */],
		LightboxTrailer: __WEBPACK_IMPORTED_MODULE_5__components_lightbox_LightboxTrailer__["a" /* default */],
		LightboxAbout: __WEBPACK_IMPORTED_MODULE_6__components_lightbox_LightboxAbout__["a" /* default */],
		LightboxMobile: __WEBPACK_IMPORTED_MODULE_7__components_lightbox_LightboxMobile__["a" /* default */],
		LightboxAdblock: __WEBPACK_IMPORTED_MODULE_8__components_lightbox_LightboxAdblock__["a" /* default */]
	},
	computed: {
		activeSectionClass: function activeSectionClass() {
			return 'active--' + this.$store.getters.activeSection.slug;
		}
	},
	mounted: function mounted() {
		var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent.substr(0, 4)) || window.innerWidth <= 720;
		var today = new Date().getTime();
		if (isMobile && localStorage.getItem('mobilePopup') - today <= 0) {
			document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-mobile');
		}
	}
});

/***/ }),

/***/ "Jt5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__ = __webpack_require__("5KfQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: { LightboxBase: __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__["a" /* default */] },
	methods: {
		close: function close() {
			document.querySelector('html').classList.remove('lightbox--active', 'lightbox--active-adblock');
			if (typeof localStorage !== 'undefined') {
				localStorage.setItem('adblock', __WEBPACK_IMPORTED_MODULE_1_moment__().add(1, 'day').unix());
			}
		}
	}
});

/***/ }),

/***/ "KNlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__("JNZ0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ac7d70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__("OwbB");
function injectStyle (ssrContext) {
  __webpack_require__("5sNZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ac7d70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LDUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1254be68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("jajf");
function injectStyle (ssrContext) {
  __webpack_require__("OK8u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1254be68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mb5m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.statusClass,attrs:{"id":"program"}},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"program__date",domProps:{"innerHTML":_vm._s(_vm.mainHeaderHTML)}}),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_vm._l((_vm.projections),function(projection,index){return _c('program-item',{key:projection.id,attrs:{"projection":projection,"index":index},nativeOn:{"click":function($event){_vm.selectProjection(projection)}}})}),_vm._v(" "),_c('a',{staticClass:"btn btn--creme more",attrs:{"href":"#nacist-vice"},on:{"click":function($event){$event.preventDefault();_vm.loadMore()}}},[_c('span',[_vm._v(_vm._s(_vm.loadingCopy))]),_vm._v(" "),_c('i')])],2),_vm._v(" "),_c('span',{staticClass:"loading"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{staticClass:"sprite ico-calendar",attrs:{"href":"#"}},[_vm._v("Kalendář")]),_vm._v(" "),_c('h2',[_vm._v("Program")]),_vm._v(" "),_c('div',{attrs:{"id":"calendar"}},[_c('ul',[_c('li',[_c('a',{staticClass:"active",attrs:{"href":""}},[_vm._v("12.12.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"active",attrs:{"href":""}},[_vm._v("12.12.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"active",attrs:{"href":""}},[_vm._v("12.12.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("12.12.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("12.12.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("12.12.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("12.12.")])])]),_vm._v(" "),_c('a',{staticClass:"nav nav-prev",attrs:{"href":""}},[_vm._v("Prev")]),_vm._v(" "),_c('a',{staticClass:"nav nav-next",attrs:{"href":""}},[_vm._v("Next")])]),_vm._v(" "),_c('form',{attrs:{"id":"search"}},[_c('input',{attrs:{"type":"text","placeholder":"Lolita"}})]),_vm._v(" "),_c('a',{staticClass:"sprite ico-search",attrs:{"href":"#"}},[_vm._v("Hledani")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mfiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LightboxBase',{staticClass:"mobile",attrs:{"close":_vm.close}},[_c('h2',[_vm._v("🚨 Bacha!")]),_vm._v(" "),_c('p',[_vm._v("Právě vstupujete na neprobádané území. Pro kvalitní zážitek s hledáním filmů ve vašem oblébeném kině doporučujeme stáhnout aplikaci ArtKina pro váš chytrý telefon.")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"http://bit.ly/akgpweb","target":"_blank"}},[_vm._v("🤖  ArtKina pro Android")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://bit.ly/aiosweb","target":"_blank"}},[_vm._v("🍎  ArtKina pro iOS")])])]),_vm._v(" "),_c('p',[_vm._v("Bez okolků přiznáváme, že jsme mobilní verzi "),_c('strong',[_vm._v("Moje Artkina")]),_vm._v(" nevěnovali tolik pozornosti a péče, protože naše hlavní úsilí směřujeme do aplikací pro Android, iOS a Desktop. Proto může být zážitek z používání "),_c('strong',[_vm._v("Moje Artkina")]),_vm._v(" poněkud trpký...")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"http://bit.ly/akgpweb","target":"_blank"}},[_vm._v("🤖  ArtKina pro Android")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://bit.ly/aiosweb","target":"_blank"}},[_vm._v("🍎  ArtKina pro iOS")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MwnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		'close': Function
	}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fuckadblock__ = __webpack_require__("ZByo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fuckadblock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fuckadblock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_google_adsense__ = __webpack_require__("8xvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_google_adsense___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_google_adsense__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




 // eslint-disable-line



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__("B60x"));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_google_adsense___default.a.Adsense);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_google_adsense___default.a.InArticleAdsense);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_google_adsense___default.a.InFeedAdsense);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
	id: 'UA-109050712-1',
	checkDuplicatedScript: true,
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	autoTracking: {
		pageviewTemplate: function pageviewTemplate(route) {
			return {
				page: route.path,
				title: document.title,
				location: window.location.href
			};
		}
	}
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
	mounted: function mounted() {
		var self = this;
		if (typeof window.fuckAdBlock !== 'undefined') {
			window.fuckAdBlock.onDetected(function () {
				if (typeof localStorage !== 'undefined') {
					var timestamp = localStorage.getItem('adblock');
					timestamp = parseInt(timestamp === null ? 0 : timestamp);
					if (timestamp <= __WEBPACK_IMPORTED_MODULE_5_moment__().unix()) {
						document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-adblock');
					}
				}
				self.$ga.event('adBlock', 'detect');
			});
			window.fuckAdBlock.onNotDetected(function () {
				self.$ga.event('adBlock', 'nodetect');
			});
			window.fuckAdBlock.check();
		} else {
			self.$ga.event('adBlock', 'nodetect');
		}
	}
});

/***/ }),

/***/ "OK8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OS4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__ = __webpack_require__("5KfQ");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: { LightboxBase: __WEBPACK_IMPORTED_MODULE_0__LightboxBase_vue__["a" /* default */] },
	computed: {
		url: function url() {
			return 'https://www.youtube.com/embed/' + this.$store.state.trailer;
		},
		close: function close() {
			return function () {
				this.$store.commit('trailer', null);
			};
		}
	}
});

/***/ }),

/***/ "OwbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('heading'),_vm._v(" "),_c('main',{class:_vm.activeSectionClass},[_c('cinemas'),_vm._v(" "),_c('program'),_vm._v(" "),_c('detail')],1),_vm._v(" "),_c('LightboxTrailer'),_vm._v(" "),_c('LightboxAbout'),_vm._v(" "),_c('LightboxMobile'),_vm._v(" "),_c('LightboxAdblock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q5al":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},

	methods: {
		href: function href(venue) {
			return '#' + venue.slug;
		},
		toggleCity: function toggleCity(city) {
			this.$store.dispatch('toggleCity', city);
		},
		toggleCinema: function toggleCinema(cinema) {
			this.$store.dispatch('toggleCinema', cinema);
		},
		isActive: function isActive(cinema) {
			return cinema.active ? 'active' : 'inactive';
		}
	},
	created: function created() {
		var self = this;
		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.$store.getters.apiUrl + '/cinema/').then(function (response) {
			self.$store.dispatch('cinemas', response.data.data);
		}).catch(function (error) {
			console.log(error);
		});

		if (this.$route.params.id) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.$store.getters.apiUrl + '/projection/detail/' + this.$route.params.id).then(function (response) {
				self.$store.commit('projection', response.data.data);
			}).catch(function (error) {
				console.log(error);
			});
		}
	}
});

/***/ }),

/***/ "R3ok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxTrailer_vue__ = __webpack_require__("OS4i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078ff820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxTrailer_vue__ = __webpack_require__("9YM3");
function injectStyle (ssrContext) {
  __webpack_require__("micX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxTrailer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078ff820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxTrailer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rx05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VY5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Program_vue__ = __webpack_require__("Br1U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a1104c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Program_vue__ = __webpack_require__("Mb5m");
function injectStyle (ssrContext) {
  __webpack_require__("7osB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Program_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a1104c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Program_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ve78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"cinemas"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},_vm._l((_vm.$store.getters.getCinemas),function(cinemas,city){return _c('ul',[_c('li',{attrs:{"index":"0"}},[_c('strong',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();_vm.toggleCity(city)}}},[_c('span',[_vm._v(_vm._s(city))]),_vm._v(" "),_c('i'),_c('em',[_vm._v(_vm._s(_vm.$store.getters.selectedCinemas(city).length)+"/"+_vm._s(cinemas.length))])]),_vm._v(" "),_c('ul',_vm._l((cinemas),function(cinema){return _c('li',{class:_vm.isActive(cinema)},[_c('a',{attrs:{"href":_vm.href(cinema)},on:{"click":function($event){$event.preventDefault();_vm.toggleCinema(cinema)}}},[_vm._v(_vm._s(cinema.name))])])}))])])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',[_vm._v("Seznam kin")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Homepage__ = __webpack_require__("KNlE");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'Homepage',
		component: __WEBPACK_IMPORTED_MODULE_2__views_Homepage__["a" /* default */]
	}, {
		path: '/:title/:id',
		name: 'Movie detail',
		component: __WEBPACK_IMPORTED_MODULE_2__views_Homepage__["a" /* default */]
	}]
}));

/***/ }),

/***/ "ZoGd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bSCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxMobile_vue__ = __webpack_require__("0xle");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ab73f8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxMobile_vue__ = __webpack_require__("Mfiw");
function injectStyle (ssrContext) {
  __webpack_require__("4fAa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ab73f8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dfjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	computed: {
		hasPreviousBtn: function hasPreviousBtn() {
			return this.$store.state.activeSectionIndex > 0;
		},
		hasNextBtn: function hasNextBtn() {
			var sections = this.$store.state.sections;
			return this.$store.state.activeSectionIndex < sections.length - 1;
		},
		prevSection: function prevSection() {
			var _$store$state = this.$store.state,
			    index = _$store$state.activeSectionIndex,
			    sections = _$store$state.sections;

			return sections[index - 1];
		},
		nextSection: function nextSection() {
			var _$store$state2 = this.$store.state,
			    index = _$store$state2.activeSectionIndex,
			    sections = _$store$state2.sections;

			return sections[index + 1];
		}
	},
	methods: {
		showSection: function showSection(type) {
			var prevIndex = this.$store.state.activeSectionIndex - 1;
			var nextIndex = this.$store.state.activeSectionIndex + 1;
			var sections = this.$store.state.sections;
			switch (type) {
				case 'previous':
					if (prevIndex >= 0) {
						this.$store.commit('activeSectionIndex', prevIndex);
					}
					break;
				case 'next':
					if (nextIndex < sections.length) {
						this.$store.commit('activeSectionIndex', nextIndex);
					}
					break;
			}
		},
		openAboutLightbox: function openAboutLightbox() {
			document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-about');
		}
	}
});

/***/ }),

/***/ "hyUH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iBsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxAdblock_vue__ = __webpack_require__("Jt5U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18804b90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxAdblock_vue__ = __webpack_require__("iXGy");
function injectStyle (ssrContext) {
  __webpack_require__("ZoGd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxAdblock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18804b90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxAdblock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iXGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LightboxBase',{staticClass:"adblock",attrs:{"close":_vm.close}},[_c('div',{staticClass:"adblock__content"},[_c('h2',[_vm._v("Vypněte si AdBlock, prosím!")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"0","padding-bottom":"45%","position":"relative"}},[_c('iframe',{staticClass:"giphy-embed",staticStyle:{"position":"absolute"},attrs:{"src":"https://giphy.com/embed/3ohzdYjwEQuR1J7dte?video=0","width":"100%","height":"100%","frameBorder":"0","allowFullScreen":""}})]),_vm._v(" "),_c('p',{staticClass:"giphy"},[_c('a',{attrs:{"href":"https://giphy.com/gifs/alien-sigourney-weaver-ripley-3ohzdYjwEQuR1J7dte"}},[_vm._v("via GIPHY")])]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tArtKina pro vás děláme zcela zdarma ve volném čase."),_c('br'),_vm._v("\n\t\t\t\tReklamy nám přináší alespoň pár korun, které nám pomáhají získávat motivaci v ArtKinech pokračovat."),_c('br'),_vm._v("\n\t\t\t\tBudeme rádi, když si AdBlock vypnete a přispějete nám tím třeba na pivo."),_c('br'),_vm._v("\n\t\t\t\tDěkujeme!\n\t\t\t")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jajf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "llWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxAbout_vue__ = __webpack_require__("6SfK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_411f159e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxAbout_vue__ = __webpack_require__("3i1B");
function injectStyle (ssrContext) {
  __webpack_require__("Bb2j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxAbout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_411f159e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxAbout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "micX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rvlR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6Ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
	nameTheDate: function nameTheDate(date) {
		var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY';

		if (!date) return '&nbsp;';
		__WEBPACK_IMPORTED_MODULE_0_moment__["locale"]('cs');
		var today = __WEBPACK_IMPORTED_MODULE_0_moment__().format(format);
		switch (true) {
			case date === today:
				return 'Dnes';
			case date === __WEBPACK_IMPORTED_MODULE_0_moment__(today, format).add(1, 'days').format(format):
				return 'Zítra';
			case date === __WEBPACK_IMPORTED_MODULE_0_moment__(today, format).add(2, 'days').format(format):
				return 'Pozítří';
			default:
				return __WEBPACK_IMPORTED_MODULE_0_moment__(date, format).format('dddd');
		}
	}
});

/***/ }),

/***/ "u25I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wHgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__("0MoM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e3accd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__("y36W");
function injectStyle (ssrContext) {
  __webpack_require__("LDUU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e3accd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app'
});

/***/ }),

/***/ "y36W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.fake,attrs:{"id":"detail"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[(_vm.fake)?_c('span',{staticClass:"skeleton__copy"},[_c('h3',[_vm._v("👈 Vyberte film z programu.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"detail__ticket"},[_c('div',{staticClass:"ticket__poster",style:(_vm.poster)}),_vm._v(" "),_c('div',{staticClass:"ticket__detail",style:(_vm.cinemaLogo)},[_c('h3',[_c('span',{staticClass:"cinema"},[_vm._v(_vm._s(_vm.cinema.name)+":")]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.day)+" "+_vm._s(_vm.time)+":")]),_vm._v(" "+_vm._s(_vm.movie.title))]),_vm._v(" "),(_vm.projection.price)?_c('p',{staticClass:"ticket__price"},[_vm._v(_vm._s(_vm.projection.price)+" Kč")]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"sharing"},[_c('li',[_c('a',{staticClass:"btn btn--blue",attrs:{"href":_vm.shareFacebookUrl,"target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.shareFacebook($event)}}},[_c('span',[_vm._v("Facebook")]),_vm._v(" "),_c('i')])])]),_vm._v(" "),_c('table',[_c('tbody',[(_vm.movie.title_orig)?_c('tr',[_vm._m(1),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm.movie.title_orig))])])]):_vm._e(),_vm._v(" "),(_vm.movie.director)?_c('tr',[_vm._m(2),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm.movie.director))])])]):_vm._e(),_vm._v(" "),(_vm.projection.language)?_c('tr',[_vm._m(3),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm.projection.language))])])]):_vm._e(),_vm._v(" "),(_vm.movie.year)?_c('tr',[_vm._m(4),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm.movie.year))])])]):_vm._e(),_vm._v(" "),(_vm.movie.length)?_c('tr',[_vm._m(5),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm.movie.length)+" min")])])]):_vm._e(),_vm._v(" "),(_vm.projection.csfd_rating || _vm.projection.imdb_rating)?_c('tr',[_vm._m(6),_vm._v(" "),_c('td',[_c('span',[(_vm.projection.csfd_rating)?_c('span',[_vm._v(_vm._s(_vm.projection.csfd_rating)+" (ČSFD)")]):_vm._e(),_vm._v(" "),(_vm.projection.imdb_rating)?_c('span',[_vm._v(_vm._s(_vm.projection.imdb_rating)+" (IMDB)")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('tr',[_vm._m(7),_vm._v(" "),_c('td',[_c('span',[_c('a',{attrs:{"href":_vm.cinema.tel}},[_vm._v(_vm._s(_vm.cinema.phone))]),_vm._v(", "),_c('a',{attrs:{"href":_vm.cinema.mailto}},[_vm._v(_vm._s(_vm.cinema.email))])])])]),_vm._v(" "),(_vm.projection.csfd_link)?_c('tr',[_vm._m(8),_vm._v(" "),_c('td',[_c('span',[_c('a',{attrs:{"href":_vm.projection.csfd_link,"target":"_blank"}},[_vm._v("csfd.cz")])])])]):_vm._e()])]),_vm._v(" "),(_vm.movie.youtube)?_c('div',{staticClass:"detail__trailer"},[_c('a',{staticClass:"btn btn--creme",attrs:{"href":_vm.youtube,"target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.playTrailer($event)}}},[_c('span',[_vm._v("► Trailer")]),_vm._v(" "),_c('i')])]):_vm._e(),_vm._v(" "),(_vm.projection.tickets)?_c('div',{staticClass:"detail__tickets"},[_c('a',{staticClass:"btn btn--creme",attrs:{"href":_vm.projection.tickets,"target":"_blank"}},[_c('span',[_vm._v("Koupit vstupenky")]),_vm._v(" "),_c('i')])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"detail__plot"},[_c('span',[_vm._v(_vm._s(_vm.movie.description))])]),_vm._v(" "),_c('aside',{staticClass:"detail__cinema"},[_c('img',{attrs:{"src":_vm.cinema.map}}),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('h4',[_c('a',{attrs:{"href":_vm.cinema.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.cinema.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cinema.address)),_c('br'),_vm._v(_vm._s(_vm.cinema.zip)+", "+_vm._s(_vm.cinema.city))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',[_vm._v("Projekce")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Originální název")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Režie")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Znění")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Rok")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Délka")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Hodnocení")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Rezervace")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('span',[_vm._v("Odkazy")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zGu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cinemas_vue__ = __webpack_require__("Q5al");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28efeba0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cinemas_vue__ = __webpack_require__("Ve78");
function injectStyle (ssrContext) {
  __webpack_require__("rvlR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cinemas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28efeba0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cinemas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9ae094a792da58c1c39b.js